const LIGHT = {
    pageBg: '#F5F5F5',
    chatBg: '#FFFFFF',
    headerBg: '#FFFFFF',
    headerBorder: '#E8E8E8',
    botBubble: '#EFEFEF',
    userBubble: '#8700DB',
    inputBg: '#F0F0F0',
    inputAreaBg: '#FFFFFF',
    textPrimary: '#1A1A1A',
    textSecondary: '#666666',
    dateText: '#999999',
    borderColor: '#E8E8E8',
    avatarBg: '#8700DB',
    iconColor: '#666666',
    attachmentBg: '#FFFFFF',
    attachmentHover: '#F5F5F5',
};

const DARK = {
    pageBg: '#161616',
    chatBg: '#191919',
    headerBg: '#1F1F1F',
    headerBorder: '#313131',
    botBubble: '#3F3F3F',
    userBubble: '#8700DB',
    inputBg: '#2D2D2F',
    inputAreaBg: '#191919',
    textPrimary: '#FFFFFF',
    textSecondary: '#959595',
    dateText: '#727272',
    borderColor: '#313131',
    avatarBg: '#8700DB',
    iconColor: '#959595',
    attachmentBg: '#2D2D2F',
    attachmentHover: '#3F3F3F',
};

const useChatTheme = (isDark) => isDark ? DARK : LIGHT;

export default useChatTheme;
